import Vue from 'vue'
import Router from "vue-router";

import HomeView from '../views/HomeView.vue'
import LoginView from "../views/Login.vue"
import LoginProviderView from "../views/LoginProvider.vue"
import ProfileView from "../views/Profile/ProfileView.vue";

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: '',
    component: LoginView
  },
  {
    path: '/provider',
    name: '',
    component: LoginProviderView
  },
  {
    path: '/home',
    name: 'inicio',
    component: HomeView
  },
  {
    path: '/profile',
    name: '',
    component: ProfileView
  },
  {
    path: '/ventas',
    name: 'ventas',
    component: HomeView
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: HomeView
  },
  {
    path: '/gerencia',
    name: 'gerencia',
    component: HomeView
  },
  {
    path: '/gerente',
    name: 'gerente',
    component: HomeView
  },
  {
    path: '/logistica',
    name: 'logistica',
    component: HomeView
  },
  {
    path: '/tesoreria',
    name: 'tesoreria',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
];

export default new Router({
  mode: 'hash',
  // base: process.env.BASE_URL,
  // mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes
})
